import axios from 'axios'
const WorkflowModule = {
  namespaced: true,
  state: {
    workflowRecords: [],
    workflows: [],
    workflowSubs: [],
    workflowGroups: [],
    selectedWorkflowRecordId: ''
  },
  mutations: {
    SET_WORKFLOWRECORD_ID: (state, payload) => {
      state.selectedWorkflowRecordId = payload
    },

    FETCH_WORKFLOWRECORD: (state, payload) => {
      state.workflowRecords = payload
    },
    FETCH_WORKFLOW: (state, payload) => {
      state.workflows = payload
    },
    FETCH_WORKFLOWSUB: (state, payload) => {
      state.workflowSubs = payload
    },
    FETCH_WORKFLOWGROUP: (state, payload) => {
      state.workflowGroups = payload
    }
  },
  actions: {
    async fetchWorkflowRecord({ commit }, payload) {
      try {
        const response = await axios.get(`portal/workflow/record/${payload}`)
        commit('FETCH_WORKFLOWRECORD', response.data)
      } catch (error) {
        // const notification = {
        //   type: 'error',
        //   message: 'Workflow Record was a problem: ' + error.message
        // }
        // dispatch('Notification/add', notification, { root: true })
        throw new Error(error)
      }
    },
    async fetchWorkflow({ commit }, payload) {
      try {
        const response = await axios.get(`portal/workflow/${payload}`)
        commit('FETCH_WORKFLOW', response.data)
      } catch (error) {
        // const notification = {
        //   type: 'error',
        //   message: 'Workflow was a problem: ' + error.message
        // }
        // dispatch('Notification/add', notification, { root: true })
        throw new Error(error)
      }
    },
    async fetchWorkflowSub({ commit }, payload) {
      try {
        const response = await axios.get(`portal/workflow/sub/${payload}`)
        commit('FETCH_WORKFLOWSUB', response.data)
      } catch (error) {
        // const notification = {
        //   type: 'error',
        //   message: 'Workflow was a problem: ' + error.message
        // }
        // dispatch('Notification/add', notification, { root: true })
        throw new Error(error)
      }
    },
    async fetchWorkflowGroup({ commit }, payload) {
      try {
        const response = await axios.get(`portal/workflow/group/${payload}`)
        commit('FETCH_WORKFLOWGROUP', response.data)
      } catch (error) {
        // const notification = {
        //   type: 'error',
        //   message: 'Workflow was a problem: ' + error.message
        // }
        // dispatch('Notification/add', notification, { root: true })
        throw new Error(error)
      }
    }
  },
  getters: {
    getWorkflowRecords: state => {
      return state.workflowRecords
    },
    getWorkflows: state => {
      return state.workflows
    },
    getWorkflowSubs: state => {
      return state.workflowSubs
    },
    getWorkflowGroups: state => {
      return state.workflowGroups
    }
  }
}

export default WorkflowModule
